/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import { ConfigProvider } from 'antd';
import enUS from 'antd/lib/locale/en_US';

import { MuiProvider } from 'components/MuiProvider/MuiProvider';
import SupportChatWidget from 'containers/SupportChatWidget';
import { useBroadcastChannel } from 'broadcastChannels/useBroadcastChannel';

export const App = ({ children }) => {
  useBroadcastChannel();

  return (
    <MuiProvider>
      <ConfigProvider locale={enUS}>
        <div style={{ height: '100%' }}>
          <Helmet titleTemplate="%s - Deed" defaultTitle="Deed" />
          {React.Children.toArray(children)}
          <SupportChatWidget />
        </div>
      </ConfigProvider>
    </MuiProvider>
  );
};

App.propTypes = {
  children: PropTypes.node,
};

export default App;
